import React, { isValidElement, PureComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View, Dimensions } from 'react-native';
import { QLinearGradient } from 'qunar-react-native';
import Theme, { Icon, Colors } from '@qnpm/q-theme';
import { filterProps, getButtonStyles } from './handle';
import { EXCLUDES_TOUCHABLE_PROPS, ACTIVE_OPACITY } from './constant';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const { scenes: { lrGradientColors } } = Colors;
// icon展示位置
var IconPosition;
(function (IconPosition) {
    IconPosition[IconPosition["LEFT"] = 0] = "LEFT";
    IconPosition[IconPosition["RIGHT"] = 1] = "RIGHT";
})(IconPosition || (IconPosition = {}));
const { layout } = Theme;
/**
 * 按钮基类
 */
export default class BaseButton extends PureComponent {
    constructor(props) {
        super(props);
        const { needScale = false } = props;
        const { button } = layout;
        this.layoutSize = needScale ? button.scaled : button.unscaled;
        this.onChange = this.onChange.bind(this);
        this.state = { refreshWidth: Dimensions.get('window').width };
    }
    onChange(dimensions) {
        const { width } = dimensions.window;
        this.setState({ refreshWidth: width });
    }
    componentDidMount() {
        // 适配折叠屏
        Dimensions.addEventListener('change', this.onChange);
    }
    componentWillUnmount() {
        Dimensions.removeEventListener('change', this.onChange);
    }
    /**
     * 是否支持渐变
     */
    get supportGradient() {
        const { shape, outline, type, needGradient } = this.props;
        return (shape === 'capsule' &&
            (type === 'normal' || type === 'primary') &&
            !outline &&
            needGradient);
    }
    render() {
        // 将不必要的属性过滤掉，剩下的直接传给touchableOpacity组件
        const touchableOpacityProps = filterProps(this.props, EXCLUDES_TOUCHABLE_PROPS);
        // 计算样式
        const buttonStyles = getButtonStyles(this.props);
        const { gradientColors } = this.props;
        // 支持渐变
        if (this.supportGradient) {
            return (<TouchableOpacity accessible={false} activeOpacity={ACTIVE_OPACITY} {...touchableOpacityProps}>
                    <QLinearGradient colors={gradientColors} start={{ x: 0.0, y: 0.5 }} end={{ x: 1.0, y: 0.5 }} style={[
                styles.contentView,
                buttonStyles.wrapper,
                styles.bgGradient,
                { maxWidth: this.state.refreshWidth - 48 }
            ]}>
                        {this.renderContentView(buttonStyles)}
                    </QLinearGradient>
                </TouchableOpacity>);
        }
        return (<TouchableOpacity accessible={false} activeOpacity={ACTIVE_OPACITY} style={[
            styles.contentView,
            buttonStyles.wrapper,
            { maxWidth: this.state.refreshWidth - 48 }
        ]} {...touchableOpacityProps}>
                {this.renderContentView(buttonStyles)}
            </TouchableOpacity>);
    }
    /**
     * 渲染按钮（包括图标和文字）
     * @param buttonStyle
     */
    renderContentView(buttonStyle) {
        const { leftIcon, rightIcon } = this.props;
        // 是否能展示右侧图标 - 左右图标不能同时出，如果同时传了的话默认展示左侧图标
        const canShowRightIcon = !leftIcon && rightIcon;
        return (<>
                {this.renderIconView(buttonStyle, IconPosition.LEFT, leftIcon)}
                {this.renderTextView(buttonStyle)}
                {canShowRightIcon
            ? this.renderIconView(buttonStyle, IconPosition.RIGHT, rightIcon)
            : null}
            </>);
    }
    /**
     * 渲染按钮图标
     * @param buttonStyle
     * @param icon
     * @param position
     */
    renderIconView(buttonStyle, position, icon) {
        var _a, _b;
        const isLeft = position === IconPosition.LEFT;
        // 没有icon时直接返回
        if (!icon) {
            return null;
        }
        // icon容器样式
        const iconWrapperStyle = isLeft
            ? { marginRight: this.layoutSize.iconSpace }
            : { marginLeft: this.layoutSize.iconSpace };
        return (<View style={iconWrapperStyle}>
                {isValidElement(icon) ? (icon) : (<Icon name={icon} needScale={this.props.needScale} style={{ paddingTop: this.layoutSize.iconPadding }} size={(_a = buttonStyle.icon) === null || _a === void 0 ? void 0 : _a.fontSize} color={(_b = buttonStyle.icon) === null || _b === void 0 ? void 0 : _b.color}/>)}
            </View>);
    }
    /**
     * 渲染按钮文字
     * @param buttonStyle
     */
    renderTextView(buttonStyle) {
        const { text, accessibilityPreName } = this.props;
        if (!text) {
            return null;
        }
        // 如果是自定义元素，则直接返回
        if (isValidElement(text)) {
            return text;
        }
        return (<Text {...qAccessibilityLabel(`${accessibilityPreName}qdButton#${text}`)} numberOfLines={1} style={[styles.titleText, buttonStyle.text]}>
                {text}
            </Text>);
    }
}
BaseButton.defaultProps = {
    text: 'Button',
    type: 'primary',
    size: 'medium',
    leftIcon: '',
    rightIcon: '',
    outline: false,
    shape: 'capsule',
    customStyle: {},
    needGradient: false,
    gradientColors: [
        lrGradientColors.leftColor,
        lrGradientColors.rightColor
    ],
    accessibilityPreName: ''
};
const styles = StyleSheet.create({
    contentView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    titleText: {
        backgroundColor: 'transparent',
        fontWeight: 'normal',
        // 安卓垂直居中
        textAlignVertical: 'center',
        includeFontPadding: false
    },
    bgGradient: {
        overflow: 'hidden',
        borderWidth: 0
    }
});
